import { defineComponent as _defineComponent } from 'vue';
import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-218c6798"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "successfully-insured"
};
const _hoisted_2 = {
  class: "content"
};
const _hoisted_3 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "insured-image"
}, null, -1));
const _hoisted_4 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "insured-text"
}, "您已投保成功", -1));
const _hoisted_5 = {
  class: "insured-btn"
};
import { onMounted, getCurrentInstance } from 'vue';
// import { toProduct } from '@/utils/navitiveApi/common'
import MainButton from '@/components/MainButton/MainButton.vue';
export default /*#__PURE__*/_defineComponent({
  __name: 'SuccessfullyInsured',
  setup(__props) {
    var _getCurrentInstance$p, _getCurrentInstance;
    const {
      $alert,
      $loading
    } = (_getCurrentInstance$p = (_getCurrentInstance = getCurrentInstance()) === null || _getCurrentInstance === void 0 ? void 0 : _getCurrentInstance.proxy) !== null && _getCurrentInstance$p !== void 0 ? _getCurrentInstance$p : {};
    onMounted(() => {
      // toProduct()
      // $alert({
      //     message: '弹框',
      // })
    });
    return (_ctx, _cache) => {
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_hoisted_3, _hoisted_4, _createElementVNode("div", _hoisted_5, [_createVNode(MainButton, {
        onClick: _ctx.onClickNext
      }, {
        default: _withCtx(() => [_createTextVNode("查看保单")]),
        _: 1
      }, 8, ["onClick"])])])]);
    };
  }
});